import { css } from '@emotion/react'
import rgba from 'color-alpha'

import { Theme } from '@surglogs-app/ui.theme'

import { mediaQueries } from '../mediaQueries'
import { ButtonVariant } from '../uiKit/services/ButtonService'
import { getColorKeyFromColorVariant } from '../uiKit/services/TypographyService'

export const visuallyHidden = () => ({
  border: 0,
  clip: 'rect(0 0 0 0)',
  height: 1,
  width: 1,
  margin: -1,
  padding: 0,
  overflow: 'hidden',
  position: 'absolute',
})

export const textEllipsisProps = {
  ws: 'nowrap',
  overflow: 'hidden',
  tow: 'ellipsis',
} as const

export const textEllipsis = () => css`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

export const clearFix = () => css`
  &:after {
    clear: both;
    content: '';
    display: table;
  }
`

export const textWrap = () => css`
  word-break: break-word;
`

export const absoluteCenter = () => css`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`

export const absoluteVerticalCenter = () => css`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
`
export const absoluteHorizontalCenter = () => css`
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
`

export const withDefaultMaxWidths = ({ theme }: { theme: Theme }) => css`
  width: 100%;
  max-width: ${theme.maxWidth.md};

  ${mediaQueries.md({ theme })} {
    max-width: ${theme.maxWidth.xs};
  }
`

export const getDefaultOutline = ({
  theme,
  variant,
  disabled,
}: {
  theme: Theme
  variant: ButtonVariant
  disabled?: boolean
}) => {
  let color = theme.ui.colors[getColorKeyFromColorVariant(variant)]

  if (disabled) {
    color = theme.ui.colors['navy.10']
  }

  if (variant === 'transparent') {
    return null
  }

  return css`
    outline: none;
    box-shadow: 0 0 0 3px ${rgba(color, 0.25)};
  `
}

export const getInputBlockPadding = ({
  theme,
  type = 'prop',
}: {
  theme: Theme
  type?: 'value' | 'prop'
}) => {
  const value = `calc((${theme.ui.spacings.xxl} - ${theme.ui.typography.lineHeights.sm}) / 2)`

  if (type === 'value') {
    return value
  }

  return css`
    padding-block: ${value};
  `
}

export const getCalcString = (initialValue: string, vals: number[]) =>
  `calc(${initialValue} + ${vals.join('px + ')}px)`
